//      
import {               } from 'css-box-model';
                                            
import { add } from '../position';

export default (viewport          , point          )           =>
  add(viewport.scroll.diff.displacement, point);



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/with-scroll-change/with-viewport-displacement.js